import { ISteps } from '../models/StepperModel';

// steps components
import FindYourBusiness from './FindYourBusiness/view/Index';
import SiteBuilder from './SiteBuilder/view/Index';
import CategoryKeywords from './CategoryKeywords/view/Index';
import Design from './Design/view/Index';
import SocialMedia from './SocialMedia/view/Index';
import PreparingWebsite from './PreparingWebsite/view/Index';

// steps
import FindYourBusinessStep from './FindYourBusiness/Step';
import SiteBuilderStep from './SiteBuilder/Step';
import CategoryKeywordsStep from './CategoryKeywords/Step';
import SocialMediaStep from './SocialMedia/Step';
import DesignStep from './Design/Step';
import PreparingWebsiteStep from './PreparingWebsite/Step';

import {
  GROUP_DEFAULT,
  STEP_FIND_YOUR_BUSINESS,
  STEP_PURCHASE_INFORMATION,
  STEP_SITE_BUILDER,
  STEP_CATEGORY_KEYWORDS,
  STEP_DESIGN,
  STEP_SOCIAL_MEDIA,
  STEP_PREPARING_WEBSITE
} from './steps-definitions';

export const WIZARD_STEPS: ISteps = {
  [STEP_FIND_YOUR_BUSINESS]: {
    component: FindYourBusiness,
    possibleNextSteps: [STEP_CATEGORY_KEYWORDS],
    step: new FindYourBusinessStep(),
    group: GROUP_DEFAULT,
    style: {
      visibleInformationPanel: true
    }
  },
  [STEP_CATEGORY_KEYWORDS]: {
    component: CategoryKeywords,
    possibleNextSteps: [STEP_SOCIAL_MEDIA],
    step: new CategoryKeywordsStep(),
    group: GROUP_DEFAULT,
    style: {
      visibleInformationPanel: true
    }
  },
  [STEP_SOCIAL_MEDIA]: {
    component: SocialMedia,
    possibleNextSteps: [STEP_DESIGN],
    step: new SocialMediaStep(),
    group: GROUP_DEFAULT,
    style: {
      visibleInformationPanel: true
    }
  },
  [STEP_DESIGN]: {
    component: Design,
    possibleNextSteps: [STEP_PREPARING_WEBSITE],
    step: new DesignStep(),
    group: GROUP_DEFAULT,
    style: {
      visibleInformationPanel: true
    }
  },
  [STEP_PREPARING_WEBSITE]: {
    component: PreparingWebsite,
    possibleNextSteps: [STEP_SITE_BUILDER],
    step: new PreparingWebsiteStep(),
    group: GROUP_DEFAULT,
    style: {
      visibleInformationPanel: true
    }
  },
  [STEP_SITE_BUILDER]: {
    component: SiteBuilder,
    possibleNextSteps: [STEP_PURCHASE_INFORMATION],
    group: GROUP_DEFAULT,
    step: new SiteBuilderStep(),
    style: {
      visibleInformationPanel: true
    }
  }
};
export { STEP_FIND_YOUR_BUSINESS };
